const formatted = (value) => value ? new Intl.DateTimeFormat("it-IT", { day: "numeric", month: "long", year: "numeric",
  timeZone: "Europe/Rome" }).format(new Date(value)) : null;

export const MetaAdSignal = ({ data }) => {
  if (!data) return null;
  let text = "Dato non disponibile";
  if (data.status === "not_checked") text = "Non verificata";
  if (data.status === "available" && data.attive_ora) text = `Attiva dal ${formatted(data.active_since || data.ultima_inserzione) || "periodo non indicato"}`;
  if (data.status === "available" && !data.attive_ora && data.numero_inserzioni_90gg > 0)
    text = `Ultima inserzione ${formatted(data.ultima_inserzione) || "negli ultimi 90 giorni"}`;
  if (data.status === "available" && !data.attive_ora && !data.numero_inserzioni_90gg)
    text = "Nessuna negli ultimi 90 giorni";
  return <div className="meta-ad-signal" data-testid="meta-ad-signal"><span>Pubblicità Meta: <strong data-testid="meta-ad-status">{text}</strong></span>
    {data.ad_library_url && <a href={data.ad_library_url} target="_blank" rel="noopener noreferrer"
      data-testid="meta-ad-library-link">Libreria inserzioni ↗</a>}
  </div>;
};